import React from 'react';
import { Layout } from 'antd';
import { Route, Routes } from 'react-router-dom';
import SidebarMenu from './SidebarMenu';
import MainTable from '../Home/MainTable';
import AppHeader from '../common/Header';
import AdminUsersPanel from '../Admin/AdminUsersPanel';
import { AuthContext } from '../../context/AuthContext';
import MapPage from '../../features/map-2026/MapPage';

const { Content, Sider } = Layout;

const AppLayout = () => {
  const { principal } = React.useContext(AuthContext);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider>
        <SidebarMenu />
      </Sider>
      <Layout>
        <AppHeader />
        <Content style={{ margin: '16px' }}>
          <Routes>
            <Route path="main" element={<MainTable />} />
            <Route path="map-v2" element={<MapPage />} />
            <Route path="admin/users" element={<AdminUsersPanel principal={principal} />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
